import TableRow from "../../../../Components/Common/TableRow";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import TableData from "../../../../Components/Common/TableData";
import TableRowPerAction from "../../../../Components/Common/TableRowPerAction";
import useToastError from "../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import { modelTestUrls } from "../../../../Api/Auth/ApiUrls";
import { sendDeleteRequestAuth } from "../../../../Api/swrConfig";
import { toast } from "react-toastify";
import { useAlert } from "../../../../Context/AlertContext";

const FreeModelTestRow = ({ row, mutate }) => {
  const { showErrorToast } = useToastError();
  const { showAlert } = useAlert();

  const { trigger: deleteTrigger } = useSWRMutation(
    modelTestUrls.deleteFreeModelTestTaker(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        showErrorToast(error);
      },
    },
  );

  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the free model test user?`,
      async () => {
        await deleteTrigger(row._id);
      },
    );
  };

  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row.email}</TableData>
        <TableData>{row?.modelTest?.title}</TableData>
        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
        <TableRowPerAction onDelete={handleDelete} />
      </TableRow>
    </>
  );
};

export default FreeModelTestRow;
